import * as React from 'react';
import { DragDropContext, Draggable, Droppable, DropResult, ResponderProvided } from 'react-beautiful-dnd';

// import ui
import { DefaultButton, Panel, PanelType, PrimaryButton, Stack, Text } from '@fluentui/react';

// import interfaces

// import services

// import component
import LoadingComponent from '../../../../../components/loading';
import GeneralConfig from '../../../../../config';

import styles from './styles.module.scss';
import ToppingServices from '../../../../../services/toppings';
import { IToppingResourceShort } from '../../../../../props/toppings';

interface ISortToppingsPanelProps {
  closePanel: (r: boolean) => void;
}

interface IUpdateToppings {
  toppingId: string;
  orderNumber: number;
}

interface ISortToppingsPanelState {
  submiting: boolean;
  loaded: boolean;
  toppings: IToppingResourceShort[];
  updateToppings: IUpdateToppings[];
}

export default class SortToppingsPanel extends React.Component<
  ISortToppingsPanelProps,
  ISortToppingsPanelState
> {
  constructor(props: ISortToppingsPanelProps) {
    super(props);

    this.state = {
      submiting: false,
      loaded: false,
      toppings: [],
      updateToppings: [],
    };
  }

  componentDidMount() {
    this.getToppings();
  }

  private getToppings = async () => {
    this.setState({ loaded: false });
    try {
      const toppings = await ToppingServices.retrieve();
      this.setState({ loaded: true, toppings });
    } catch (error) {
      this.setState({ loaded: false });
    }
  };

  public render() {
    const { loaded, submiting, toppings } = this.state;
    return (
      <Panel
        headerText='Ubah Urutan Topping'
        type={PanelType.medium}
        isOpen
        onDismiss={() => this.props.closePanel(false)}
        onRenderFooterContent={this.onRenderFooter}
        isFooterAtBottom={true}
        closeButtonAriaLabel='Close'
      >
        {loaded && (
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId='droppable'>
              {(provided, snapshot) => (
                <section {...provided.droppableProps} ref={provided.innerRef}>
                  {toppings.map((f, index) => (
                    <Draggable key={f.id} draggableId={f.id} index={index}>
                      {(provided, snapshot) => (
                        <section
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            ...provided.draggableProps.style,
                            position: 'static',
                            background: '#ffffff',
                          }}
                          className={styles.columnItem}
                        >
                          <Stack
                            key={f.id}
                            className={styles.item}
                            horizontal
                            verticalAlign='center'
                            tokens={{ childrenGap: 10 }}
                          >
                            {f.images.map((i) => (
                              <img
                                key={i.id}
                                src={GeneralConfig.assetsHostname + '/' + i.url}
                                className={styles.image}
                              />
                            ))}
                            <Text>{f.name}</Text>
                          </Stack>
                        </section>
                      )}
                    </Draggable>
                  ))}
                </section>
              )}
            </Droppable>
          </DragDropContext>
        )}
      </Panel>
    );
  }

  private onSubmit = async () => {
    const { updateToppings } = this.state;

    const data = updateToppings.map((u) => ({ ...u, orderNumber: String(u.orderNumber) }));
    const fd = new FormData();
    this.setState({ submiting: true });
    try {
      data.map((d) => fd.append('toppings[]', JSON.stringify(d)));
      await ToppingServices.reorder(fd);
      this.setState({ submiting: false });
      this.props.closePanel(true);
    } catch (error) {
      this.setState({ submiting: false });
    }
  };

  private onDragEnd = (result: DropResult, provided: ResponderProvided) => {
    const { toppings: items } = this.state;
    let newNumber: number = 0;

    const lastIndex = items.length - 1;
    if (result.destination) {
      const to = result.destination.index;
      const from = result.source.index;

      if (Number(items[from].orderNumber) > Number(items[to].orderNumber)) {
        if (to - 1 !== lastIndex) {
          if (items[to - 1]) {
            newNumber = (Number(items[to].orderNumber) + Number(items[to - 1].orderNumber)) / 2;
          } else {
            newNumber = Number(items[to].orderNumber) / 2;
          }
        } else {
          newNumber = Number(items[to].orderNumber) - 1;
        }
      } else {
        if (items[to + 1]) {
          newNumber = (Number(items[to].orderNumber) + Number(items[to + 1].orderNumber)) / 2;
        } else {
          newNumber = Number(items[to].orderNumber) + 1;
        }
      }

      Number.isNaN(newNumber) && (newNumber = Math.floor(Math.random() * 10) + 1);

      this.updateColumns(items, from, to, newNumber);

      this.updateOrderNumber(newNumber, items[from]);
    }
  };

  private updateOrderNumber = async (orderNumber: number, topping: IToppingResourceShort) => {
    const { updateToppings } = this.state;
    const findToppings = updateToppings.findIndex((f) => f.toppingId === topping.id);
    if (updateToppings[findToppings]) {
      updateToppings[findToppings].orderNumber = orderNumber;
    } else {
      updateToppings.push({ toppingId: topping.id, orderNumber: orderNumber });
    }

    this.setState({ updateToppings });
  };

  private onRenderFooter = () => {
    if (!this.state.submiting) {
      return (
        <Stack horizontal tokens={{ childrenGap: 10 }}>
          {this.state.updateToppings.length !== 0 && <PrimaryButton text='Save' onClick={this.onSubmit} />}
          <DefaultButton text='Cancel' onClick={() => this.props.closePanel(false)} />
        </Stack>
      );
    } else {
      return <LoadingComponent label={'Mengubah Urutan Topping'} />;
    }
  };

  private updateColumns = (
    toppings: IToppingResourceShort[],
    from: number,
    to: number,
    newOrderNumber: number
  ) => {
    toppings[from].orderNumber = String(newOrderNumber);
    this.setState({ toppings: this._reorder(toppings, from, to) });
  };

  private _reorder = (list: IToppingResourceShort[], startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };
}
